export const ProductsData = [
  {
    id: "1",
    category: "Industrial Automation Technology",
    title: "Automatic Batching System",
    to: "/products/batchingsystem",
  },
  {
    id: "2",
    category: "Internet of Things (IoT)",
    title: "IoT SIM Card Module",
    to: "/products/iotsimcard",
  },
];
export const ProjectsData = [
  {
    id: "1",
    category: "Machine Learning",
    title: "Cow detection",
    to: "/projects/cowdetection",
  },
];

export const CompanyData = [
  {
    id: "1",
    category: "About us...",
    title: "Who We Are",
    to: "/company/whoweare",
  },
];

export const Languages = [
  {
    id: "1",
    category: "",
    title: "فارسی",
    to: "/",
  },
  {
    id: "2",
    category: "",
    title: "English",
    to: "/",
  },
];
